export interface InspectionRecord {
  id: string
  personalNummer: string // Operator or supervisor ID
  personalName: string // Operator or supervisor name
  chargennummer: string
  produktNr: string
  linie: string
  sollgewicht: string
  referenztemperatur: string // e.g., "5-7°C"
  intervallzeit: number // in minutes
  gewicht: number
  temperatur: number
  datum: Date
  chipNr?: string // Only if temperature was below threshold
  fehlerMeldung?: string // Error/warning message
  isQuittiert: boolean // Whether this was acknowledged by supervisor
}

export function formatInspectionTime(date: Date): string {
  return date.toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

export function getInspectionStatus(record: InspectionRecord): {
  label: string
  color: string
} {
  if (record.fehlerMeldung) {
    return {
      label: 'Quittiert',
      color: 'yellow',
    }
  }

  if (record.temperatur < 5 || record.temperatur > 7) {
    return {
      label: 'Warnung',
      color: 'red',
    }
  }

  return {
    label: 'OK',
    color: 'green',
  }
}
